"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var LivestreamAttendanceMap = function (_a) {
    var statistics = _a.statistics, _b = _a.title, title = _b === void 0 ? 'Livestream Event' : _b, _c = _a.date, date = _c === void 0 ? '' : _c, _d = _a.googleKey, googleKey = _d === void 0 ? null : _d;
    var _e = (0, react_1.useState)([]), prevStatistics = _e[0], setPrevStatistics = _e[1];
    var _f = (0, react_1.useState)(false), googleChartsLoaded = _f[0], setGoogleChartsLoaded = _f[1];
    if (!googleKey) {
        var keyEl = document.getElementsByClassName('google-key')[0];
        if (keyEl) {
            googleKey = keyEl.getAttribute('data-google-key');
        }
    }
    (0, react_1.useEffect)(function () {
        if (googleChartsLoaded && JSON.stringify(prevStatistics) === JSON.stringify(statistics)) {
            return;
        }
        setGoogleChartsLoaded(true);
        var handleBeforeUnload = function () {
            setGoogleChartsLoaded(false);
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        var drawChart = function () {
            var formattedData = [['Country', 'Attendance']];
            statistics.forEach(function (item) {
                formattedData.push([item.country, item.attendance]);
            });
            var dataTable = window.google.visualization.arrayToDataTable(formattedData);
            var options = {
                backgroundColor: '#e2e8f0',
                datalessRegionColor: '#ffffff',
                displayMode: 'regions',
                colorAxis: { minValue: 0, colors: ['#ddd5e8', '#32145b'] },
                legend: { textStyle: { color: '#32145b', fontSize: 16 } },
                geochartVersion: 11,
                domain: 'US',
            };
            var chart = new window.google.visualization.GeoChart(document.getElementById('livestream_attendance_map'));
            chart.draw(dataTable, options);
        };
        var loadGoogleCharts = function () {
            var script = document.createElement('script');
            script.src = 'https://www.gstatic.com/charts/loader.js?loading=async';
            if (googleKey) {
                script.src += '&key=' + encodeURIComponent(googleKey);
            }
            script.onload = function () {
                window.google.charts.load('current', {
                    packages: ['geochart'],
                    mapsApiKey: googleKey,
                });
                script.async = true;
                window.google.charts.setOnLoadCallback(drawChart);
            };
            document.body.appendChild(script);
        };
        if (!window.google) {
            loadGoogleCharts();
        }
        else {
            drawChart();
        }
        setPrevStatistics(statistics);
    }, [statistics]);
    return (react_1.default.createElement(material_1.Card, { sx: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            p: 2,
            m: 2,
        } },
        react_1.default.createElement(material_1.CardContent, { sx: {
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                p: 2,
            } },
            react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h6", gutterBottom: true },
                title,
                " -",
                ' ',
                date ? new Date(date).toLocaleDateString() : new Date().toLocaleDateString()),
            react_1.default.createElement(material_1.Box, { sx: { width: '100%', height: '100%', position: 'relative' } },
                !window.google && (react_1.default.createElement(material_1.CircularProgress, { sx: { position: 'absolute', top: '50%', left: '50%' } })),
                react_1.default.createElement(material_1.Box, { id: "livestream_attendance_map", sx: { width: '100%', height: '100%' } })))));
};
exports.default = LivestreamAttendanceMap;
